import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from '../services/client.service';
import { FeatureFlagService, Shared, UserService } from '@rubii/frontend-common';
import { User } from '@rubii/frontend-common/lib/models/account/User';
import { TWO_FACTOR_VERIFICATION_COOKIE_NAMES, TwoFactorEvents, twoFAFeatureId } from '../verification/two-factor-verification.constants';
import { VerificationService } from '../services/verification.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {
  callbackData: {
    code?: string;
    state?: string;
    error?: string;
    error_description?: string;
  } = {};

  constructor(private route: ActivatedRoute, private verificationService: VerificationService, private feature: FeatureFlagService, private userService: UserService, private client: ClientService, private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.callbackData = {
        code: params['code'],
        state: params['state'],
        error: params['error'],
        error_description: params['error_description']
      };
      
      console.log('Cognito callback data:', this.callbackData);
      
      if (this.callbackData.code) {
        this.handleSuccessfulAuth(this.callbackData.code, this.callbackData.state);
      }
    });
  }

  async handleSuccessfulAuth(code: string, state?: string) {
    let user: any;
    try {    
      user = await this.client.user.exchangeToken(window.location.hostname, code);
    } catch(e) {
      
    }
    if (!user) {
      this.callbackData.error = "Authentication failed";
      this.callbackData.code = undefined;
      this.callbackData.error_description = "You have no permission to access this application.";
      return;
    }
    this.userService.user = user as any;
    this.client.updateToken(this.userService.user?.token);
    if (user.fromSSO) {
        Shared.helpers.CookieHelper.setCookie('sso-domain', window.location.hostname.toLowerCase());
    }
    this.feature.featureEnabled = this.feature.featureEnabled || {};
    try {
        this.feature.updateUserToken(user.token);
        await this.feature.register([twoFAFeatureId]);
    } catch (e) {
        console.log("Failed to load feature flags", e);
    }
    
    const host = (typeof window !== 'undefined' && window.location && window.location.hostname) ?
        window.location.hostname.toLowerCase() : '';
    const isNovaEnv = host.includes('nova');
    const isLocalhost = host === 'localhost' || host === '127.0.0.1';
    const twoFaFeatureOn = !user.fromSSO && !isLocalhost && (isNovaEnv || !!this.feature.featureEnabled[twoFAFeatureId]);
    if (!twoFaFeatureOn) {
        // On localhost, set 2FA passed cookie to bypass auth guard 2FA check
        if (isLocalhost || user.fromSSO) {
            Shared.helpers.CookieHelper.setCookie('rubii-2fa-passed', 'true');
        }
        if (this.userService.isExternal || user.fromSSO) {
            window.location.href = this.userService.getTrackerUrl() + "/list";
        } else {
            Shared.helpers.CookieHelper.deleteCookie(
                "visited-" +
                this.userService.user.tenant.id +
                "-" +
                this.userService.user.id
            );
            let url = document.referrer;
            if (!url || url.toLowerCase().indexOf("login") >= 0) {
                window.location.href = this.userService.getTrackerUrl() + "/list";
            } else {
                window.location.href = url;
            }
        }
    } else {
        const isLocked = await this.client.user.isLocked(user.email);
        if (isLocked && !user.fromSSO) {
            this.router.navigate(['/lock']);
            return;
        }
        const isExternal = this.userService.isExternal;
        const trackUrl = this.userService.getTrackerUrl();
        this.verificationService.exactLoginRedirect(isExternal, this.userService.user, trackUrl);

        Shared.helpers.CookieHelper.setCookie(`${TWO_FACTOR_VERIFICATION_COOKIE_NAMES.TWO_FACTOR_TRUSTED_DEVICE_CHECKED}-${this.userService.user.email}`, "true");
        const existTrustDeviceStr = Shared.helpers.CookieHelper.getCookie(`${TWO_FACTOR_VERIFICATION_COOKIE_NAMES.TWO_FACTOR_TRUSTED_DEVICE}-${this.userService.user.email}`);
        const oldCookieStr = Shared.helpers.CookieHelper.getCookie(TWO_FACTOR_VERIFICATION_COOKIE_NAMES.TWO_FACTOR_TRUSTED_DEVICE);
        if ((oldCookieStr === "true" && !!user.last_login) || existTrustDeviceStr === "true") {
            Shared.helpers.CookieHelper.setCookie(TWO_FACTOR_VERIFICATION_COOKIE_NAMES.TWO_FACTOR_PASSED, "true");
            this.verificationService.gotoRedirectUrl();
            return;
        }
    }
  
    
  }


  goBackToLogin(): void {
    this.router.navigate(['/account/login']);
  }
}
